const NAMESPACE = 'Core'

export const STATUS_CHANGED = NAMESPACE + '/StatusChanged'
export const STATUS_DISCARDED = NAMESPACE + '/StatusDiscarded'

// reducers

export function statusReducer(status = null, action) {
    switch(action.type) {
        case STATUS_CHANGED:
            return action.status
        case STATUS_DISCARDED:
            return null
        default:
            return status
    }
}

// actions

export function status(type, message, timeout = 5000) {
    return {
        type: STATUS_CHANGED,
        status: {
            type: type,
            message: message,
            timeout: timeout
        }
    }
}

export function infoStatus(message, timeout = 5000) {
    return {
        type: STATUS_CHANGED,
        status: {
            type: 'info',
            message: message,
            timeout: timeout
        }
    }
}

export function errorStatus(message, timeout = 5000) {
    return {
        type: STATUS_CHANGED,
        status: {
            type: 'danger',
            message: message,
            timeout: timeout
        }
    }
}

export function discardStatus() {
    return {
        type: STATUS_DISCARDED,
    }
}

// middlewares

export function statusMiddleware({dispatch}) {
    var timer

    return (next) => (action) => {
        if (action.type == STATUS_CHANGED) {
            if (timer) {
                clearTimeout(timer)
            }

            if (action.status.timeout) {
                timer = setTimeout(() => {
                    dispatch(discardStatus())
                }, action.status.timeout)
            }
            return next(action)
        }
        return next(action)
    }
}


// WEBPACK FOOTER //
// ./lib/core/redux/status.js